import { isPlatformServer } from '@angular/common';
import { Directive, ElementRef, HostBinding, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { sleep } from 'src/app/lib/sleep';
import { StateService } from 'src/app/services/state.service';

@Directive({
  selector: '[animateInView]',
  standalone: true,
})
export class AnimateWhenInViewDirective implements OnInit {
  @HostBinding('class') elementClass: string;
  @Input() animateInView: string;
  @Input() minDelay: number;
  inView = false;
  buffer = 20;
  startTime: number;

  @HostListener('window:scroll', ['$event']) winScroll() {
    if (this.inView) return;
    this.calcInView();
  }

  @HostListener('window:resize', ['$event']) winResize() {
    if (this.inView) return;
    this.calcInView();
  }

  constructor(
    private el: ElementRef<HTMLElement>,
    @Inject(PLATFORM_ID) private platformId: string,
    private state: StateService,
    private route: ActivatedRoute
  ) {
    this.startTime = Date.now();
  }

  async ngOnInit() {
    if (this.route.snapshot.queryParams._storyblok) return;
    if (!this.elementClass) this.elementClass = '';
    this.elementClass += 'animation-' + this.animateInView + ' ';
    if (isPlatformServer(this.platformId)) return;
    if (ScreenSizes.screenSize() === 'mobile') {
      this.buffer = 10;
    }
    if (this.animateInView === 'up') {
      this.buffer -= 50;
    }
    if (this.minDelay) await sleep(this.minDelay);
    await sleep(0);
    this.calcInView();
  }

  private canAnimate() {
    if (!this.minDelay) return true;
    return Date.now() - this.startTime >= this.minDelay;
  }

  calcInView() {
    if (!this.el) return;
    if (!this.canAnimate()) return;
    const rect = this.el.nativeElement.getBoundingClientRect();
    if (rect.top < window.innerHeight - this.buffer) {
      this.inView = true;
      this.elementClass += ' animated';
    }
  }
}
